export enum AdsPlatform {
  Default = 1,
  Tablet = 2,
  Mobile = 3,
}
